import { render, staticRenderFns } from "./ClassWarnModel.vue?vue&type=template&id=f63fde0a&scoped=true&xmlns%3A=true"
import script from "./ClassWarnModel.vue?vue&type=script&lang=js"
export * from "./ClassWarnModel.vue?vue&type=script&lang=js"
import style0 from "./ClassWarnModel.vue?vue&type=style&index=0&id=f63fde0a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63fde0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f63fde0a')) {
      api.createRecord('f63fde0a', component.options)
    } else {
      api.reload('f63fde0a', component.options)
    }
    module.hot.accept("./ClassWarnModel.vue?vue&type=template&id=f63fde0a&scoped=true&xmlns%3A=true", function () {
      api.rerender('f63fde0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/statistic/ClassWarnModel.vue"
export default component.exports